import React, {useEffect, useState} from 'react';

import styles from "../css/Commentator.module.css";
import Button from "components/inputs/Button";
import CommentatorForm from "components/form/CommentatorForm";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import userImage from "../../asset/images/userImage.png";

import CommentatorService from "service/apiConfig/CommentatorService";
import { imageMimeType } from "../../config";
import { useDispatch, useSelector } from "react-redux";
import { commentatorActions } from "reducers/commentator";
import Swal from "sweetalert2";
import checkByteSize from "../../service/util/checkByteSize";

const CommentatorModal = () => {
    const dispatch = useDispatch();
    const commentatorDetail = useSelector(state => state.commentatorData.commentatorDetail);
    const commentatorImageFile = useSelector(state => state.commentatorData.commentatorImageFile);
    const openDetail = useSelector(state => state.commentatorData.openDetail);
    const previewImage = useSelector(state => state.commentatorData.previewImage);

    const [fileDataUrl, setFileDataUrl] = useState(null);

    useEffect(() => {
        let fileReader, isCancel = false;
        if (previewImage !== null) {
            fileReader = new FileReader();
            fileReader.onload = (e) => {
                const { result } = e.target;
                if (result && !isCancel) {
                    setFileDataUrl(result);
                }
            };
            fileReader.readAsDataURL(previewImage? previewImage : null);
        }
        return () => {
            isCancel = true;
            if (fileReader && fileReader.readyState === 1) {
                fileReader.abort();
            }
        }
    }, [previewImage]);

    const handleCloseDetail = () => {
        dispatch(commentatorActions.setOpenDetail(false));
        dispatch(commentatorActions.setCommentatorDetail({}));
        dispatch(commentatorActions.setFile(null));
        dispatch(commentatorActions.setPreviewImage(null));
    }

    const onChangeInput = (e) => {
        const { name, value } = e.target;
        dispatch(commentatorActions.setCommentatorDetail({
            ...commentatorDetail,
            [name]: value
        }));
    }

    const onChangeSwitch = (e) => {
        dispatch(commentatorActions.setCommentatorDetail({
            ...commentatorDetail,
            invalid: !e.target.checked
        }));
    }

    const onChangeImageFileHandler = (e) => {
        e.preventDefault();
        const imageFile = e.target.files[0];
        if (!imageFile.type.match(imageMimeType)) {
            Swal.fire({
                text: "해당 형식의 파일은 지원하지 않습니다.\nJPG, PNG 파일을 등록해 주세요.",
                icon: 'warning',
                confirmButtonText: '확인',
            }).then(r => { if (r.isConfirmed) {
                return false;
            }});
        } else if (checkByteSize(imageFile.size)) {
            dispatch(commentatorActions.setOpenDetail(false));
            Swal.fire({
                text: `이미지 용량은 5MB 이내로 등록 가능합니다.`,
                icon: 'warning',
                confirmButtonText: '확인',
            }).then(r => { if (r.isConfirmed) {
                dispatch(commentatorActions.setOpenDetail(true));
                return false;
            }});
        } else {
            dispatch(commentatorActions.setFile(imageFile));
            dispatch(commentatorActions.setPreviewImage(imageFile));
        }
    }

    const onEdit = () => {
        const formData = new FormData();
        const commentatorData = {
            "id": commentatorDetail.id,
            "name": commentatorDetail.name,
            "nameEng": commentatorDetail.nameEng,
            "invalid": commentatorDetail.invalid,
            "imageAltText": "test",
        }
        formData.append('commentator', JSON.stringify(commentatorData));
        formData.append('file', commentatorImageFile);
        CommentatorService.update(formData)
            .then(response => {
                dispatch(commentatorActions.setOpenDetail(false));
                Swal.fire({
                    text: '수정이 완료되었습니다.',
                    icon: 'success',
                    confirmButtonText: '확인',
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.replace("/setting/commentator");
                    } else return false;
                })
            })
            .catch(err => console.log(err));
    }
    return (
        <>
        {openDetail &&
            <Dialog
                className={styles.commModal}
                open={openDetail}
                fullWidth={true}
                maxWidth={"sm"}
                onClose={(_, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseDetail();
                    }
                }}>
                <DialogTitle>
                    <div className={"modalHeader"}>
                        <Button style={{ background: "#5a54a1" }} onClick={onEdit}>수정</Button>
                        <Button style={{ background: "#fff", border: "1px solid #bbb", color: "#222", padding: "0.5rem" }} onClick={handleCloseDetail}>나가기</Button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <CommentatorForm
                        id={commentatorDetail.id}
                        name={commentatorDetail.name}
                        nameEng={commentatorDetail.nameEng}
                        invalid={commentatorDetail.invalid}
                        imageUrl={previewImage === null ? commentatorDetail.imageUrl : fileDataUrl !== null ? fileDataUrl : userImage}
                        onChangeInput={onChangeInput}
                        onChangeSwitch={onChangeSwitch}
                        onChangeImageFileHandler={onChangeImageFileHandler}
                        className={styles.commModalForm}
                    />
                </DialogContent>
            </Dialog>
        }
        </>
    );
};

export default CommentatorModal;